import React from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useConfirmation } from "../../components/commonComponents/ConfirmationDialog";

export const useJoinMeeting = (
  wsRef,
  handleLogs,
  connected,
  firstName,
  join_room_role,
  handleRequestMedia,
  permission,
  isAdminOrCM,
) => {
  /**
   * Joins the meeting room with the specified role and name.
   * Requests media permissions first to ensure tracks are available for peer connection.
   */
  const location = useLocation();
  const showConfirmation = useConfirmation();

  const handleJoinMeeting = React.useCallback(
    async (data) => {
      // Show confirmation dialog only for participants (not admin/CM) when no location search
      if (location.search === "" && !isAdminOrCM) {
        // toast.info(
        //   "Please remove your spectacles during the video call meeting.",
        //   { autoClose: 5000, toastId: "remove_spectacles_during_meeting" },
        // );
        showConfirmation({
          message:
            "Please remove your spectacles during the video call meeting.",
          header: "Video Call Reminder",
          icon: "pi pi-info-circle",
          acceptLabel: "Ok",
          acceptClassName:
            "bg-red-600 text-white hover:bg-red-700 px-8 py-2 rounded-md font-semibold transition-all duration-200 border-none shadow-sm",
          accept: async () => {
            // User clicked Ok - proceed with joining the meeting
            // Ensure media is available before joining the room
            if (permission !== "granted") {
              try {
                await handleRequestMedia();
              } catch (error) {
                handleLogs("Cannot join meeting without media permissions");
                return;
              }
            }

            if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
              toast.error("WebSocket is not connected", {
                toastId: "ws_not_connected_error",
              });
              return;
            }

            try {
              wsRef.current.send(
                JSON.stringify({
                  type: "join_room",
                  user_name: firstName || "User",
                  role: join_room_role,
                }),
              );
              handleLogs("Joining meeting...");
            } catch (error) {
              handleLogs(`Error joining meeting: ${error.message}`);
            }
          },
        });
      } else {
        // For admin/CM or when location search exists, proceed directly
        // Ensure media is available before joining the room
        if (permission !== "granted") {
          try {
            await handleRequestMedia();
          } catch (error) {
            handleLogs("Cannot join meeting without media permissions");
            return;
          }
        }

        if (!wsRef.current || wsRef.current.readyState !== WebSocket.OPEN) {
          toast.error("WebSocket is not connected", {
            toastId: "ws_not_connected_error",
          });
          return;
        }

        try {
          wsRef.current.send(
            JSON.stringify({
              type: "join_room",
              user_name: firstName || "User",
              role: join_room_role,
            }),
          );
          handleLogs("Joining meeting...");
        } catch (error) {
          handleLogs(`Error joining meeting: ${error.message}`);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      wsRef,
      handleLogs,
      firstName,
      join_room_role,
      permission,
      handleRequestMedia,
      isAdminOrCM,
      location,
    ],
  );

  return { handleJoinMeeting };
};
